<template>
  <div class="class-charts">
    <!-- 总得分情况 -->
    <div class="canvas-box" id="myTotalBar"></div>
  </div>
</template>
<script>
export default {
  props: ["model"],
  mounted() {
    if (this.model) {
      this.renderMap();
    }
  },
  watch: {
    model(val) {
      if (val) {
        this.renderMap();
      }
    },
  },
  methods: {
    renderMap() {
      let score = [];
      if (this.model) {
        let value = this.model.split(",");
        if (value.length == 3) {
          score = value;
        }
      }
      let totleNum = 30;
      let values1 = parseInt(score[0])+parseInt(score[1])+parseInt(score[2]);
      let showNum = parseInt((values1 * 100) / 30);
      let myTotalBar = (window.cc = this.$echarts.init(
           document.getElementById("myTotalBar")
      ));
      let option = {
        backgroundColor: "#fff",
        legend: {
          data: ["正确题目数"],
          left: 10,
          itemWidth: 14,
          top: 90,
        },
        grid: {
          left: "3%",
          right: "4%",
          containLabel: true,
          height: 50,
          top: 30,
        },
        xAxis: {
          type: "value",
          max: 30,
          interval: 10,
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: true,
            interval: 10,
            lineStyle: {
              width: 1,
              color: "#333",
            },
          },
        },
        yAxis: {
          type: "category",
        },
        graphic: [
          { type: "text", left: "17%", top: "10", style: { text: "一般" } },
          { type: "text", left: "48%", top: "10", style: { text: "良好" } },
          { type: "text", left: "80%", top: "10", style: { text: "优秀" } },
          {
            type: "text",
            left: parseInt((values1 * 100) / 30) + "%",
            top: "90",
            style: { text: showNum + "%" },
          },
          {
            type: "text",
            right: "0px",
            top: "90",
            style: { text: "总题目数" },
          },
        ],
        series: [
          {
            name: "总题目数",
            type: "bar",
            color: "#dedede",
            barWidth: 30,
            data: [totleNum],
            barGap: "-100%",
          },
          {
            name: "正确题目数",
            type: "bar",
            color: "#000080",
            barWidth: 30,
            data: [values1],
          },
        ],
      };
      myTotalBar.setOption(option);

      let that = this;
      setTimeout(function() {
        that.getBaseImage(myTotalBar);
      }, 1000);
    },

    getBaseImage(chart) {
      let imgData = chart.getDataURL({
        pixelRatio: 2,
        backgroundColor: "#fff",
      });

      // // 向父组件传图片base64格式
      // this.$parent.$parent.$parent.$parent.$parent.setImageBase(this.image1);
      this.$emit("image3", imgData);
    },
  },
};
</script>
<style lang="scss" scoped>
.class-charts {
  // position: relative;
  .canvas-box {
    width: 600px;
    height: 150px;
    margin: 10px auto 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataView/echarts/totalScore.vue